import { createSingleEntityStore } from '@core/ngrx-legacy';

export interface IntelligenceSettings {
  aiWriterEnabled: boolean;
  evaluationInsightsEnabled: boolean;
}

export const {
  actions: IntelligenceSettingsActions,
  namespace: IntelligenceSettingsNamespace,
  reducer: IntelligenceSettingsReducer,
  selectors: IntelligenceSettingsSelectors,
} = createSingleEntityStore<IntelligenceSettings>()('IntelligenceSettings');
